













import { Component, Prop, Vue } from 'vue-property-decorator';

import CheckedGreen from '@/components/icons/CheckedGreen.vue';
import CheckedRed from '@/components/icons/CheckedRed.vue';
import Checked from '@/components/icons/Checked.vue';

@Component({
  components: {
    Checked,
    CheckedGreen,
    CheckedRed
  }
})
export default class RulePassword extends Vue {
  @Prop() description!: string;
  @Prop() isValid?: boolean;
  @Prop() label?: string;

  get icon(): string {
    if (this.isValid === null) {
      return 'CheckedRed';
    } else if (this.isValid) {
      return 'CheckedGreen';
    } else {
      return 'Checked';
    }
  }
}
